import Popover from "components/Popover";
import styled from "styled-components";
import theme from "theme";

export const UserProfilePopover = styled(Popover)`
    @media (${theme.breakpoints.tabletL}) {
        display: none;
    }
`;
